<template>
  <v-dialog
    v-model="showJobDialog"
    max-width="1200px"
    :scrollable="!$vuetify.breakpoint.xsOnly"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card v-if="showJobDialog">
      <v-card-title class="primary white--text">
        <span class="headline">
          {{ $t('texts.job') }}
        </span>
        <v-spacer/>
        <v-btn text small fab @click="showJobDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container v-if="Object.keys(job).length > 0">
          <v-row>
            <v-col :cols="12" :md="7">
              <p>{{ $t('texts.preview') }}</p>
              <div v-html="job.introduction"></div>
              <h2>
                {{ job.title }}
                (<span v-if="job.workload_min === 100">{{ job.workload_min }}%</span>
                <span v-else-if="job.workload_min >= job.workload_max">{{ job.workload_min }}%</span>
                <span v-else>{{ job.workload_min }} - {{ job.workload_max }}%</span>)
              </h2>
              <p>
                {{ $t('texts.months.'+[job.start_month]) }} {{ job.start_year }} -
                {{ $t('texts.months.'+[job.end_month]) }} {{ job.end_year }}
                <span v-if="job.place !== '' && job.place !== null">({{ job.place }})</span>
                <br />
              </p>
              <div class="quill__text" v-html="job.description"></div>
            </v-col>
            <v-col :cols="12" :md="4" :offset-md="1">
              <img :src="`${fileHost}/companies/${company.id}/images/standard.png?${moment().format('DD-MMMM-YYYY')}`" width="100%">
              <p>
                <strong>{{ company.name }}</strong><br>
                {{ company.street }} {{ company.street_number }}<br>
                {{ company.zip }} {{ company.place }}<br>
                {{ company.phone }}<br>
                <a v-bind:href="companyWebsite" target="_blank">{{ companyWebsite }}</a>
              </p>
              <p v-if="job.accommodation">
                {{ $t('texts.lodging') }}
              </p>
              <map-component
                v-if="coordinates[0].lat && coordinates[0].lng"
                :mapName="`map-job-${job.id}`"
                :markers="coordinates"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { fileHost } from '@/config';
import MapComponent from '@/components/_organisms/MapComponent.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'jobDetail',
  components: {
    MapComponent,
  },
  data() {
    return {
      showJobDialog: false,
      job: {},
      company: {},
      fileHost,
      isPreview: true,
    };
  },
  mounted() {
    this.$eventBus.$on('show-job-preview-dialog', ({ job, company }) => {
      Object.assign(this.job, job);
      Object.assign(this.company, company);
      this.showJobDialog = true;
    });
    this.$eventBus.$on('hide-job-preview-dialog', () => {
      this.job = {};
      this.showJobDialog = false;
    });
  },
  computed: {
    ...mapUserState([
      'maintenanceActive',
    ]),
    coordinates() {
      const coordinates = [{
        lat: parseFloat(this.job.latitude || 0),
        lng: parseFloat(this.job.longitude || 0),
      }];
      return coordinates;
    },
    companyWebsite() {
      let url = this.company.website;
      if (!/^(f|ht)tps?:\/\//i.test(url)) {
        url = `http://${url}`;
      }
      return url;
    },
  },
};
</script>
